<template>
  <InfuseModal :title="t('iam.users.header.force_change_password')" @close="emit('close')" :disable-close="loading">
    <form id="add-user" @submit.prevent="onSubmit" class="flex flex-col gap-2">
      <InfuseNote class="mb-2">{{ t('iam.users.force_change_password_description') }}</InfuseNote>
      <InfuseField :label="t('iam.users.tempPassword')">
        <InfuseInput
          :required="true"
          v-model="tempPasswordMutation"
          ref="tempPasswordInputRef"
          :minlength="6"
          :maxlength="128"
          :placeholder="t('iam.users.tempPassword_placeholder')"
        />
      </InfuseField>
    </form>
    <template #actions>
      <InfuseButton
        data-testid="modal-cancel-button"
        color="secondary"
        type="button"
        @click="emit('close')"
        :disabled="loading"
      >
        {{ t('action.cancel') }}
      </InfuseButton>

      <InfuseButton
        data-testid="modal-confirm-button"
        type="submit"
        form="add-user"
        :disabled="loading"
        :loading="loading"
      >
        {{ t('action.submit') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { InfuseButton, InfuseField, InfuseInput, InfuseModal, InfuseNote } from '@infuse/ui/components';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const tempPasswordMutation = ref('');

const props = withDefaults(
  defineProps<{
    loading?: boolean;
  }>(),
  {
    loading: false
  }
);

interface Emits {
  (event: 'close'): void;

  (event: 'mutate', action: { tempPassword: string }): void;
}

const emit = defineEmits<Emits>();

const onSubmit = () => {
  emit('mutate', {
    tempPassword: tempPasswordMutation.value
  });
};
</script>
